import { render } from "./DocumentReglementairePage.vue?vue&type=template&id=380de192&scoped=true&ts=true"
import script from "./DocumentReglementairePage.vue?vue&type=script&lang=ts"
export * from "./DocumentReglementairePage.vue?vue&type=script&lang=ts"

import "./DocumentReglementairePage.vue?vue&type=style&index=0&id=380de192&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380de192"]])

export default __exports__